import React from 'react'
import styles from './index.module.scss'
import {AlertTypeProps} from "../../types";

interface AlertInterface{
    alertType: AlertTypeProps
    alertMessage: string
}

const alertMapper = {
    [AlertTypeProps.SUCCESS]: {
        title: "Успішно",
        icon: "success"
    },
    [AlertTypeProps.INFO]: {
        title: "Інформація",
        icon: "info"
    },
    [AlertTypeProps.WARNING]: {
        title: "Увага",
        icon: "warning"
    },
    [AlertTypeProps.ERROR]: {
        title: "Помилка",
        icon: "error"
    },
}

export default function Alert({alertType = AlertTypeProps.INFO, alertMessage}: AlertInterface){
    return (
        <div className={styles.alert}>
            <div className={styles.alert__title}>
                <img src={`/image/alert/${alertMapper[alertType].icon}.svg`} alt="success"/>
                {alertMapper[alertType].title}
            </div>
            <div className={styles.alert__description}>
                {alertMessage}
            </div>
            <div className={styles.alert__close}>
                <img src="/image/close.svg" alt="close"/>
            </div>
        </div>
    )
}
